import './skeleton-menu.scss';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

export const SkeletonMenu = () => {

    return (
        <div className='skeleton-menu'>
            <Grid container className="container">
                <Grid item xs={3}>
                    <Skeleton variant="rectangular" height={50} />

                    <div className="items">
                        <Skeleton variant="rectangular" height={50} />
                        <Skeleton variant="rectangular" height={50} />
                        <Skeleton variant="rectangular" height={50} />
                        <Skeleton variant="rectangular" height={50} />
                        <Skeleton variant="rectangular" height={50} />
                    </div>
                </Grid>
                <Grid item xs={9} className='container-skeleton-menu'>
                    <Skeleton variant="rectangular" height={40} width={500} />
                    <Skeleton variant="rectangular" height={20} width={800} />

                    <div className="contain-skeleton">
                        <Skeleton variant="rectangular" height={40} width={500} />
                        <Grid container>
                            <Grid item xs={6}>
                                <Skeleton variant="rectangular" height={200} />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="rectangular" height={200} />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={6}>
                                <Skeleton variant="rectangular" height={200} />
                            </Grid>
                            <Grid item xs={6}>
                                <Skeleton variant="rectangular" height={200} />
                            </Grid>
                        </Grid>
                        
                    </div>
                </Grid>
            </Grid>
        </div >
    );
}